import { ReactElement } from 'react';

export const splitGamesIntoUnits = <T extends ReactElement>(
	games: T[],
	itemsPerUnit: number,
	allowIncompleteUnits: boolean
) => {
	const units = [];
	const unitsAmount = Math[allowIncompleteUnits ? 'ceil' : 'floor'](games.length / itemsPerUnit);

	for (let i = 0; i < unitsAmount; i += 1) {
		const currentIndex = i * itemsPerUnit;
		units[i] = games.slice(currentIndex, currentIndex + itemsPerUnit);
	}
	return units;
};
